// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3_gFj","loaderOuter":"PageOverlayLoader_loaderOuter__3HBq7"};